module.exports = __webpack_public_path__ + "img/45.a72771b.jpg";